const weekByWeekValues = [
  {
    week: 4,
    header: 'Welcome to pregnancy!',
    content: `<p>At 4 weeks pregnant, the size of your baby is hardly measurable, it’s an embryo the size of a cupcake sprinkle. That embryo is then divided into three sections that form the baby’s vital organs. Your placenta has also started to form, which provides everything your baby needs as they both grow. Your baby is even beginning to develop a brain & central nervous system. The craziest part? All of these big developments are unnoticeable by the outside world (& maybe to you, too)!</p>
              <p>When they're 4 weeks pregnant, most moms don't even know it. Here’s why: the start of the embryonic period (aka the beginning of pregnancy) happens as soon as you miss your first period. Sometime during the end of this week you'll be able to take a home pregnancy test to confirm.</p>`,
    symptoms:
      "Most symptoms you experience during this week may be pretty similar to what you're used to feeling before your period begins. You could be getting a little bit of bleeding or cramping as your baby settles in. The pregnancy hormone progesterone will begin flowing & possibly cause some bloating & tender breasts. Then again, since it’s so early you may not experience any symptoms at all. Just remember, everybody & every baby is different!",
    yourBaby: `<ul>
    <li>Height: 2mm</li>
    <li>Weight: less than .04oz</li>
    <li>Blastocyst (collection of cells) is splitting into placenta & embryo</li>
    <li>Embryo implants into the uterine wall</li>
    <li>Placenta is starting to form</li>
    <li>Barely detectable on an ultrasound but has the makeup to become a fully developed human</li>
    <li>Amniotic sac & fluid begin to develop, ready to cushion your growing baby</li>
    <li>The amniotic sac and fluid begin to develop, ready to cushion your growing baby</li>
    </ul>`,
    yourBody: `<ul>
    <li>PMS</li> 
    <li>Missed Period</li>
    <li>Positive Pregnancy Test (Maybe?)</li>
    <li>A little light bleeding (spotting) as your embryo settles into your uterine lining</li>
    <li>Mild Cramping</li>
    <li>Sore or Tender breasts</li>
    <li>Bloating</li>
    <li>Nausea</li>
    </ul>
    `,
    tips: '- Start taking a prenatal vitamin if you haven’t already',
    faq: [
      {
        question: 'Can you get a positive pregnancy test at 4 weeks?',
        answer: 'In short, yes. A urine test can detect pregnancy at 4 weeks.',
      },
      {
        question: 'Is there a heartbeat at 4 weeks pregnant?',
        answer: 'Although growth of the heart is occurring at 4 weeks, a heartbeat is not present this early in development. At 4 weeks, a blood vessel that later develops into the heart and circulatory system exists, but not the complete heart and resulting heartbeat. A heartbeat may first be detected between 6 ½ and 7 weeks.',
      },
      {
        question: 'What should hCG be at 4 weeks?',
        answer: 'Human chorionic gonadotropin (hCG) is a hormone made by the placenta, corresponding with embryo implantation in the uterus. At 4 weeks, the range of hCG is between 4 and 426 mIU/mL (milli-international units of hCG per milliliter of blood).',
      },
      {
        question: 'When should I go to my 1st prenatal doctor appointment?',
        answer: "Once you get a positive pregnancy test, it's recomended to contact your healthcare provider and schedule your initial appointment. The initial appointment will typically be schedule between week 8 and week 10. This timeframe allows for effective confirmation of pregnancy to proceed with the standard prenatal assessments.",
      },
    ],
  },
  {
    week: 5,
    header: 'It’s week five!',
    content:
      "This is the week that the majority of women find out they are pregnant. You've missed your period by a full week, & that home pregnancy test will hopefully show you a positive result. At 5 weeks pregnant, your baby is less than a quarter of an inch long, barely the size of a sugar cube! Your little sugar is composed of three layers, the endoderm, ectoderm & mesoderm. In the weeks ahead, these layers grow into organs & tissues. The placenta & umbilical cord, although they are in very early development, are hard at work supplying oxygen & nutrients to your baby. As soon as you're for sure pregnant, it’s very important to stop smoking & drinking alcohol. This can have serious negative effects on your child, so get used to saying no to that glass of wine at dinner. In fact, there are quite a few things that you should think about saying no to now that you're 5 weeks pregnant!",
    symptoms:
      "That little embryo is growing like crazy, & your body is preparing for some very big changes in the coming weeks. In fact, by next week your baby will have doubled in size! That’s a tall order, so you can expect to feel sore breasts, fatigue & nausea. As different parts of your body change, you may also start taking those frequent trips to the bathroom to pee… yes, it can start this early!",
    yourBaby: `
    <ul>
    <li>Height: 2 mm </li>
    <li>Weight: less than .04 oz</li>
    <li>3 Germ Layers, aka group of cells making up a tiny embryo</li>
    <li>Organs are starting to develop</li>
    <li>Neural tube has formed, which is the basis for the nervous system becoming the brain & spine. </li>
    <li>Beginning to form vital organs & major systems</li>
    <li>The placenta & umbilical cord are already doing their job</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>hCG levels increase</li>
    <li>Positive Pregnancy Test</li>
    <li>Nausea (hello, morning sickness!)</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Possible spotting</li>
    <li>Mood swings</li>
    </ul>`,
    tips: `<p>-Call your doctor and schedule a prenatal appointment, which usually happens at week 8</p>
    <p>Start paying attention to the different foods and chemicals you interact with on a day-to-day basis, the safer the better!</p>`,
    faq: [
      {
        question: 'What should I expect at 5 weeks pregnant?',
        answer: `A range of symptoms are present at 5 weeks, but not everyone experiences all of the symptoms or to the same extent. Always refer to a medical professional for questions regarding symptoms like severe cramping. Possible symptoms you can expect include:
<ul><li>Morning sickness or nausea</li><li>Frequent urination</li><li>Cramping</li><li>Spotting (and possible vaginal discharge)</li><li>Fatigue</li><li>Breast changes (e.g., increased tenderness)</li><li>Smell sensitivities</li><li>Food aversions or cravings </li><li>Mood swings</li><li>Constipation</li>
</ul>`,
      },
      {
        question: 'Can you start to show at 5 weeks?',
        answer:
          'At 5 weeks, a baby is compared in size to an apple seed or orange seed. If you feel like you&rsquo;re showing, it may be more the result of bloating.',
      },
      {
        question: 'Is there a heartbeat at 5 weeks pregnant?',
        answer:
          'A vaginal ultrasound might be able to detect a heartbeat around 5 &frac12; to 6weeks. Typically a heartbeat is identified by ultrasound between 6 &frac12; to 7 weeks.',
      },
      {
        question: 'Can you have a miscarriage at 5 weeks?',
        answer:
          'Yes, a miscarriage can occur at 5 weeks. Miscarriage is a spontaneous physical process that can happen throughout the first 20 weeks of pregnancy, but is most common during the first trimester',
      },
      {
        question: 'Is it normal to feel cramping at 5 weeks?',
        answer:
          'Yes, cramping at 5 weeks pregnant can happen but is often not cause for concern. These cramps are typically due to your uterus stretching and accommodating the growing embryo. These cramps are generaully similiar to period pains or pulling sensation. Contact your healthcare provider if you are feeling uncertain about your experience. ',
      },
    ],
  },
  {
    week: 6,
    header: 'Hello week 6!',
    content: `
    <p>
    Are you used to the idea of being pregnant yet? You've got plenty of time left to let it sink in, so now its best to just go with the flow. In order to get through the difficult early stages, it’s important to appreciate the little things, like how fast your baby is growing!
    </p>
    <p>
    Pregnancy can really make your heart race, which is true for you & your baby! An increasingly developing circulatory system just started pumping blood through baby’s body, thanks to a tiny heart beating nearly twice as fast as yours. The intestines & lungs are starting to form, but the most exciting news may be that your baby’s face is starting to emerge! The eyes, nose, ears, mouth & cheeks are all making an appearance this week. What a cutie!
    </p>
    `,
    symptoms:
      "All of these changes will have an impact on your body, enough to make any person feel pretty emotional. In fact, the changes in your body’s hormone levels at 6 weeks pregnant are most likely causing your mood to fluctuate & fly all over the place. Some days you may feel overjoyed, others you could feel super moody. This is a natural part of the process & you're not alone, mama! ",
    yourBaby: `
    <ul>
    <li>Height: 6 mm</li>
    <li>Weight: less than .04 oz</li>
    <li>Baby will double in size this week!</li>
    <li>Heart starts to beat, beating 100-160 times a minute</li>
    <li>Arm & leg buds begin to develop</li>
    <li>Lungs, brain & face are all entering the early stages of growth</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Pregnancy hormone hCG is causing some intensified nausea, feelings & mood swings</li>
    <li>Morning sickness (which is NOT confined to the morning)</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Possible spotting</li>
    <li>Mood swings</li>
    </ul>`,
    tips: `
    <p>-Take pictures every week of your little bump’s progress…it goes by so fast!</p>
    <p>Check your makeup bag. The products you have been using may contain dangerous chemicals that are very harmful for your little one!</p>`,
    faq: [
      {
        question: 'What should I expect at 6 weeks pregnant?',
        answer: `The physical symptoms you can expect at 6 weeks pregnant are similar to 5 weeks. Not all pregnancies are alike, which includes the experience of physical symptoms. Always refer to a medical professional for questions regarding symptoms like severe cramping. Indicators of pregnancy at 6 weeks are:
<ul><li>Morning sickness and nausea</li><li>Gas and bloating</li><li>Fatigue</li><li>Breast changes (e.g., tenderness, size, shape)</li><li>Frequent urination</li><li>Indigestion or heartburn</li><li>Mood swings</li><li>Spotting</li><li>Cramping </li>
</ul>`,
      },
      {
        question: 'Can you have a baby bump at 6 weeks?',
        answer:
          'A baby bump is not typically visible at 6 weeks. A perceived baby bump may be attributed to bloating. As pregnancy progresses, the uterus grows and expands to make room for a baby, but at 6 weeks this growth is usually only seen by a medical professional during an ultrasound.',
      },
      {
        question: 'What week is the highest risk of miscarriage?',
        answer:
          'The highest risk for miscarriage is during the first trimester, or 13 weeks. Within the first trimester, 4-6 weeks can be the range of highest risk.',
      },
      {
        question: 'Can you be 6 weeks pregnant and test negative?',
        answer:
          'It is possible to be 6 weeks pregnant and test negative on a pregnancy test. Low hCGhormone levels may not register as positive on a home pregnancy test, which can be influenced by the timing of conception within the menstrual cycle.',
      },
    ],
  },
  {
    week: 7,
    header: 'What’s up week 7!',
    content: `
    <p> You wouldn’t be able to tell from the outside, but at 7 weeks pregnant your little bump has doubled in size yet again.</p>
    <p>Baby is hard at work developing hundreds of brain cells each minute (wow!), you're probably starting to feel the heat. At 7 weeks pregnant, your body is building the placenta aka your baby’s life support system. Your body is going through a LOT of changes, all in preparation for when your little bump isn't so little anymore.</p>
    <p>its time for the 1st prenatal appointment (if you haven't already had it). Prepare yourself for a longer appointment & a handful of samples: urine, blook & cerivical cells. Our tip: bring a list of questions & medications!</p>
    `,
    symptoms:
      "Cravings & aversions are at an all time high, thanks to a surge in hormones! Your body is smart & recognizes it needs more nutrients. Listen to your body, give it what it needs & treat yourself to your favorite meal!",
    yourBaby: `
    <ul>
    <li>Height: 1 cm</li>
    <li>Weight: less than .04 oz</li>
    <li>Digestive system begins to develop</li>
    <li>Developing a permanent set of kidneys</li>
    <li>Serious generation of brain cells</li>
    <li>Formation of arm & leg joints</li>
    <li>Facial features begin to take shape</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Frequent urge to pee (your uterus has doubled in size since week 4)</li>
    <li>Nausea</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Mood swings</li>
    <li>Food cravings & aversions</li>
    <li>Saliva</li>
    </ul>`,
    tips: `
    <p>-Although you may experience aversions to food, along with nausea, try to get in as many nutrients as you can. Stick with organic fruits and veggies, nuts, and protein, or if crackers and ginger ale is your diet right now (thanks morning sickness), make sure you take that prenatal vitamin!</p>
    <p>The usual time to announce a pregnancy is 12 weeks, but if you’re feeling antsy, don’t hold back!</p>
    `,
    faq: [
      {
        question: 'What can you feel at 7 weeks pregnant?',
        answer: `Changes that you might feel at 7 weeks can be new or a continuation from previous weeks. Among the sensations at 7 weeks are:
<ul><li>Fatigue</li><li>Nausea and vomiting</li><li>Breast changes (swollen, tender) </li><li>Bloating</li><li>Frequent urination</li><li>Food cravings and aversions</li><li>Darkening areolas</li><li>Excess saliva</li><li>Acne</li>
</ul>
Similar to previous weeks, you may experience mild cramping or sporadic spotting. If you have questions regarding severity and when to be concerned, contact a medical professional.`,
      },
      {
        question: 'Can you see a baby on an ultrasound at 7 weeks?',
        answer:
          'A baby is around the size of a blueberry at 7 weeks and therefore may not look like a&ldquo;baby&rdquo; on an ultrasound. Due to the small size at 7 weeks, a transvaginal ultrasound may offer abetter picture, which shows internal structures such as the gestation sac.',
      },
      {
        question: 'What are the chances of miscarriage at 7 weeks?',
        answer:
          'After reaching the 6-week mark of a healthy pregnancy, the chance of miscarriage is around 10 percent.',
      },
      {
        question: 'Why am I bloated at 7 weeks pregnant?',
        answer:
          'Bodily processes, such as digestion, are slowed due to progesterone. The longer digestion takes, the more gas produced that results in bloating.',
      },
    ],
  },
  {
    week: 8,
    header: 'Feelin’ great in week 8!',
    content: `
    <p>Baby is growing some basic, primitive structures that will grow into full-fledged people parts in the coming weeks. Webbed fingers & toes are growing. Baby's tail is starting to go away. Baby's brain is also making very basic neural connections, & is moving their (extremely) tiny limbs! What a crazy amount of development from what was a clump of cells a month ago!
    </p>
    `,
    symptoms:
      'You can’t feel your baby’s movements, nor can you see your bump (probably). What you CAN feel, is nausea and fatigue, which are two major first trimester symptoms. There’s also a chance that by now you’re getting some sharp pains in the side of your pelvis. These “round ligament pains” are a result of your body trying to keep up with your ever-growing uterus. Hormones are also doing their business when you’re 8 weeks pregnant. They have a hand in your morning sickness, as well as making you feel pretty emotional, and causing your breasts to grow a cup size or two. You may need to go bra shopping!',
    yourBaby: `
    <ul>
    <li>Height: 1.6 cm</li>
    <li>Weight: 0.04 oz</li>
    <li>Webbed fingers & toes</li>
    <li>Basic taste buds</li>
    <li>Liver & kidneys develop</li>
    <li>Primitive lungs & breathing tubes are growing</li>
    <li>Baby is moving constantly, even though they're too small for you to feel it</li>
    <li>Baby’s body is starting to straighten out, & very basic facial structures are appearing!</li>
    <li>Tail is starting to go away</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Nausea at at an all time high!</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Possible spotting</li>
    <li>Mood swings</li>
    <li>Vaginal discharge can be expected, possibly with some blood</li>
    <li>Heartburn, constipation, indigestion & more ramp up!</li>
    <li>Strong sense of smell</li>
    <li>Acne</li>
    <li>Mucus Plug begins to form</li>
    </ul>`,
    tips:
      'Fun fact: Traditionally, Jordan Almonds are served at weddings in groups of five, so they are indivisible, just like the newlyweds. Across many different cultures, Jordan Almonds have roots with new couples and their new babies. These tasty treats are often used to celebrate a new pregnancy or birth.',
    faq: [
      {
        question: 'Can you start to show at 8 weeks?',
        answer:
          `<p>Yes, you can start to show at 8 weeks, but there is a range from a slight bump to not showing at all. Pregnancies with multiples are more likely to show at this stage compared to a single pregnancy.</p>
          <p>If it's your second pregnancy, it's more likely to start showing at 8 weeks due to abdominal muscles stretched from the first pregnancy.</p>`,
      },
      {
        question: 'What is fetus doing at 8 weeks?',
        answer:
          'Significant growth continues at 8 weeks, including the formation of facial features,bone development and growth of arms, fingers, feet and other external physical structures. The embryonictail is vanishing while the nose and eyelids continue their growth.',
      },
      {
        question: 'What are the chances of miscarriage at 8 weeks?',
        answer:
          'After reaching the 6-week mark of a healthy pregnancy, the chance of miscarriage is around 10 percent.',
      }
    ],
  },
  {
    week: 9,
    header: 'Week 9 – time to celebrate!',
    content: `
    <p>Welcome to your third month of pregnancy! At 9 weeks pregnant, baby is weighing in at about 0.9 inches & 0.07 ounces with most of the basic physiology & essential body parts are in place.</p>
    <p>Baby's tiny heart has developed its four chambers, with a heartbeat you can see & hear through ultrasound! The eyes have developed & the placenta is nearly ready to produce hormones. That means you won't have to do it anymore! You're not quite out of the woods, but now that most of your baby’s basic structure is there the challenging part of the first trimester has an end in sight.
    </p>`,
    symptoms:
      "You're halfway through the 1st trimester, you got this! Something that’s easy to get familiar with but impossible to get used to is morning sickness. Although it often starts in the morning, it can strike at any time, thanks in part to your increased sense of smell. Getting used to those mood swings & cravings yet? At 9 weeks pregnant, your body is producing a ton of hormones that cause these symptoms. Soon enough they will calm down, but do your best to stick through it for the next few weeks! If it’s getting too rough, we have tons of natural morning sickness cures that will help any mom!",
    yourBaby: `
    <ul>
    <li>Height: 2.3 cm</li>
    <li>Weight: 0.07 oz</li>
    <li>Baby is officially a FETUS! </li>
    <li>Baby is going from being an embryo to becoming fetus!</li>
    <li>Heart has 4 chambers</li>
    <li>More complexity in organs & systems, including a possibly detectable heartbeat!</li>
    <li>Fully developed eyes, but lids that won't open until about week 27</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Morning sickness is at its peak, but often subsides around weeks 12-14</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Possible spotting</li>
    <li>Mood swings</li>
    <li>Skin changes </li>
    <li>Headache</li>
   <li> Weight gain</li>
    </ul>`,
    tips: `
    <p>-Foods might be difficult to keep down, so we recommend eating very small meals/snacks consistently to keep something in your stomach.</p>
    <p>-Be sure to keep that sensitive nose away from strong smells.</p>
    <p>-Ginger is an excellent natural nausea-fighter; try some ginger tea or ginger ale for a tasty remedy. Peppermint and acupressure wristbands have been known to help as well.</p>
    <p>-And of course, drink plenty of water and stay as hydrated as possible!</p>
    `,
    faq: [
      {
        question: 'Do you show at 9 weeks pregnant?',
        answer:
          'Bloating and the increasing size of the uterus may create a slightly noticeable belly, but the changes are more likely to be experienced by tight-fitting clothing rather than observation.A 9-week baby is the size of a grape or cherry, so signs of &ldquo;showing&rdquo; may be more apparent to only the &nbsp;expectant mom.',
      },
      {
        question: 'What are the chances of miscarriage at 9 weeks?',
        answer:
          'After reaching the 6-week mark of a healthy pregnancy, the chance of miscarriage is around 10 percent.',
      },
      {
        question: 'What should I be feeling at 9 weeks pregnant?',
        answer: `Physical changes at 9 weeks can make a pregnant woman feel her clothes fitting tighter. Other physical feelings include tender breasts, fatigue and:
<ul><li>Fatigue</li><li>Morning sickness or nausea</li><li>Frequent urination</li><li>Headaches</li><li>Sinus congestion</li><li>Mood swings</li><li>Food cravings or aversions</li><li>Increased appetite</li><li>Constipation</li><li>Heartburn</li>
</ul>`,
      },
      {
        question: 'Is 9 weeks too early to announce pregnancy?',
        answer:
          `<p>It is recommended to announce a pregnancy after the end of the first trimester, or week 13. Miscarriage risk decreases to around 5 percent after week 12, which is one reason an announcement at 9 weeks may be considered too early. </p>
          <p>However, you may decide to tell family and friends for positive support and to help get you through the first trimester! Do what feels right to you, mama! </p>`,
      },
    ],
  },
  {
    week: 10,
    header: 'You made it to week 10!',
    content: `
    <p>Your uterus is growing every week & at 10 weeks, its grown to the size of a grapefruit! You may start to notice a baby bump forming (so exciting). In terms of your little babe, this week they are forming working arm joints & is currently growing some bones & cartilage. Baby has started to flutter, although it'll be a few more weeks until you feel those special kicks! Furthermore, the vital organs that developed over the past several weeks are all starting to kick into gear. </p>
    `,
    symptoms:
      "Nausea & mood swings, & the rest of the usual symptoms, are probably still hanging around, as well as some new aches & pains. Morning sickness can be a real killer during the first trimester. There are so many nausea remedies out there, try them all & find out what works best for you to get you through the last few weeks! It feels like it will never end but we promise, it will!",
    yourBaby: `
    <ul>
    <li>Height: 1.22 inches</li>
    <li>Weight: 0.14 oz</li></li>
    <li>Fingers & toes lose no longer webbed</li>
    <li>Joints developing </li>
    <li>Knees & elbows bending</li>
    <li>Major organs are starting to function</li>
    <li>Bones & cartilage are taking shape</li>
    <li>Bones, cartilage, & even fingernails are growing steady</li>
    <li>Swallowing & kicking are your baby’s new favorite activities!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Nausea</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Mood swings</li>
    <li>Vaginal discharge</li>
    <li>Round ligament pain as the uterus exp&s</li>
    <li>Slight weight gain, & the beginnings of a bump</li>
    <li>Blossoming boobs, as well as the possibility of some hormonally induced benefits like glowing skin & luscious hair!</li>
    <li>Extra veins showing up, pumping tons of blood to your baby</li>
    </ul>`,
    tips: '',
    faq: [
      {
        question: 'Can you have a baby bump at 10 weeks?',
        answer:
          'The 10-week mark is often the time in pregnancy when a baby bump is first noticeable&mdash;at least to an expecting mom. Expansion of the uterus, muscles and ligaments to accommodate a growing baby are all part of the growing bump. Bloating can still be a contributor to a perceived bump and not everyone will see a baby bump at 10 weeks.',
      },
      {
        question: 'How likely is it to have a miscarriage at 10 weeks?',
        answer:
          'After reaching the 6-week mark of a healthy pregnancy, the chance of miscarriage is around 10 percent. The risk can decrease to 5 percent after 12 weeks.',
      },
      {
        question: 'What does a fetus look like at 10 weeks?',
        answer:
          'The fetus/baby is around 1&frac12; inches in length and weighs approximately .14ounces. Continual development of bones and cartilage include the shaping of ankles and knees and even bendable elbows. Although the size of a prune or strawberry, the baby generally looks like an actual baby.',
      },
    ],
  },
  {
    week: 11,
    header: 'Good news on Week 11!',
    content: `
    <p>At 11 weeks, baby is kicking, stretching, sighing & hiccupping. The bones in the face are forming nicely, & the proportions of the body are starting to get closer to those of a newborn’s.</p>
    <p>Reminder that the 1st Trimester is almost over! The 2nd trimester starts at 13 weeks & you can generally say goodbye to the nastier effects of hCG hormones, the hormones to blame for morning sickness & mood swings. You're almost there, mama!
    </p>
    `,
    symptoms:
      "You may start to notice a Linea Nigra (latin for black line), a dark vertical line showing up on the belly.  It’s caused by the same hormones that darken the areolas. Hormones do some crazy things! Fun fact: the reason pregnant mommies’ nipples darken is so the newborn baby has an easier time seeing them to breastfeed!",
    yourBaby: `
    <ul>
    <li>Height: 1.6 inches</li>
    <li>Weight: 0.25 oz</li>
    <li>Kicking, stretching, squeezing, & practicing other general baby acrobatics</li>
    <li>Fingers & toe nails are formed</li>
    <li>Transparent skin</li>
    <li>Bones & cartilage developing</li>
    <li>Genitals are slowly starting to form, but it will still be another 5-10 weeks before you know the gender</li>
    <li>Head is half the size of the body</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Nausea (tail end, hang in there!)</li>
    <li>Sore or Tender breasts</li>
    <li>Fatigue</li>
    <li>Frequent urination</li>
    <li>Mood swings</li>
    <li>Hair & nails are growing fast</li>
    <li>Leg & body cramps</li>
    <li>Stuffy nose</li>
    <li>A possible appearance of a dark line on your belly, Linea Nigra</li>
    </ul>`,
    tips: '',
    faq: [
      {
        question: 'Can you have a baby bump at 11 weeks pregnant?',
        answer:
          'Yes, you can have a baby bump at 11 weeks, although bloating may play a role. Second pregnancies and multiples are likely to show more progressed baby bumps.',
      },
      {
        question: 'Can you feel the baby move at 11 weeks?',
        answer:
          'First movements of the baby are referred to as &ldquo;quickening&rdquo; and usually are not noticeable until 18-20 weeks. A first-time mom may not feel movement until even later&mdash;around25 weeks, but moms who have previously experienced pregnancy may feel movement earlier, such as 12-13weeks.',
      },
      {
        question: 'What should I expect at 11 weeks pregnant?',
        answer: `Expect to feel physical symptoms of prior weeks, but since 11 weeks is approaching the end of the first trimester, the symptoms are likely to dissipate in the near future. Although not everyone experiences the same pregnancy symptoms, they can include:
<ul><li>Increased hunger</li><li>Bloating and gas</li><li>Fatigue</li><li>Frequent urination</li><li>Breast changes (e.g., tenderness, increased sized)</li><li>Morning sickness and nausea</li><li>Dizziness</li><li>Leg cramps</li><li>Vaginal discharge</li>
</ul>`,
      },
      {
        question: 'What week do you find out gender?',
        answer:
          "Determining the sex (biological indicators such as chromosomes and genitalia) of the baby typically occurs between 16 and 20 weeks. However, there are blood tests that can predict the gender as early as 9 weeks. Prior to 6 weeks, boys and girls are undifferentiated, meaning there are no physical parts indicating boy or girl that can be viewed on an ultrasound. "
      },
    ],
  },
  {
    week: 12,
    header: 'Week 12, how sweet it is!',
    content: `
    <p>Your baby is nearly done growing all of the critical systems & the foundations of the vital organs. This week, your baby is developing their reflexes - flexing fingers, curling toes & clenching eye muscles. If you give your belly a poke, your baby will move in response!</p>
    `,
    symptoms:
      "Your bump has most likely started to show. After all, your baby’s been growing pretty fast. You could also be experiencing a much-wanted end to nausea & mood swings (finally)! For those moms who are still getting nasty morning sickness at unexpected times, hang in there! It should subside by 14 weeks.",
    yourBaby: `
    <ul>
    <li>Height: 2 inches</li>
    <li>Weight: 0.49 oz</li>
    <li>Formed the majority of vital organs & systems</li>
    <li>Reflexes! Your baby will likely move in response to stimulus</li>
    <li>Digestive system will begin practicing movements</li>
    <li>Nearly ready to enter the maturation stage</li>
    <li>Baby's face is taking shape & looking more like a human every day</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Morning sickness will ease</li>
    <li>Bump starting to show</li>
    <li>Heartburn</li>
    <li>Headaches</li>
    <li>Dizziness</li>
    <li>Skin spots darken</li>
    <li>Energy levels start to rise</li>
    </ul>`,
    faq: [
      {
        question: 'Can you show at 12 weeks pregnant?',
        answer:
          'It is common for a mom to show at 12 weeks pregnant. During previous weeks, the bump may not have been noticeable to anyone but mom, but is more likely visible to others at 12 weeks.',
      },
      {
        question: 'Is first trimester over at 12 weeks?',
        answer:
          'The first trimester extends through the 13th week, although references are made to the end of the 12th week as the conclusion of the first trimester. The American Pregnancy Association identifies week 13 as the last week of the first trimester.',
      },
      {
        question:
          'How much weight should you gain in the first 12 weeks of pregnancy?',
        answer:
          'In general, you should gain between three and four pounds during the first trimester,which includes the first 12 weeks of pregnancy. Some moms will not gain this amount due to morning sickness, which isn&rsquo;t uncommon and should be recovered during the second trimester. Knowing your BMI is necessary to determine healthy weight gain at 12 weeks and beyond.',
      },
    ],
  },
  {
    week: 13,
    header: 'Welcome to week 13, the final week of your 1st trimester!',
    content: `
    <p>You're officially a third of the way there, mama! This week’s big developments are fingerprints, vocal cords, & tiny teeth. The prenatal hiccups begin to strengthening the diaphragm in preparation for breathing outside the womb. </p>
    `,
    symptoms:
      'The placenta has taken over producing hormones, which usually means you can say "GOODBYE" to the intense nausea! WOO HOO! You made it! Energy returns & your stomach FINALLY feels at ease. Go enjoy the surge of energy by taking your favorite workout class or going for a long walk outside.',
    yourBaby: `
        <ul>
    <li>Height: 2 inches</li>
    <li>Weight: 0.81 oz</li>
    <li>Vocal cords, teeth & little fingerprints are forming</li>
    <li>Kidneys developed & baby starts to pee in utero</li>
   <li>Bones begin to harden</li>
    <li>Hiccupping up a storm to strengthen the respiratory system</li>
    <li>Head is more proportional to the body with fully formed lips & a nose. What a cutie!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Bump is starting to BUMP!</li>
    <li>Less nausea </li>
    <li>Less fatigue</li>
    <li>Appetite increases</li>
    <li>Energy level increases</li>
    <li>Sex drive increases</li>
    <li>Taste aversions linger a little longer
    </ul>`,
    tips: '',
    faq: [
      {
        question: 'Can you feel the baby at 13 weeks?',
        answer:
          'First movements of the baby are referred to as &ldquo;quickening&rdquo; and usually are not noticeable until 18-20 weeks. A first-time mom may not feel movement until even later&mdash;around 25 weeks, but moms who have previously experienced pregnancy may feel movement earlier at 13 weeks.',
      },
      {
        question: 'What happens in 13th week of pregnancy?',
        answer:
          'The 13th week of pregnancy marks the continued growth of the baby and belly. Stretch marks may appear on areas such as the abdomen and hips. Physical symptoms like morning sickness may decrease while others like heartburn increase. Breast changes occur throughout pregnancy, but during the 13th week, the breasts begin to change for the purpose of future milk production. Internally, the baby is making a lot of changes too. Development occurs starting at the head and moving down to the feet, which means the head is proportionately larger.This disproportion starts to change in the 13th week. Other developing features are fingerprints, functioning kidney and urinary tracts and fine hair covering the skin.',
      },
      {
        question: 'Is 13 weeks second trimester?',
        answer: 'The 13th week is the last week of the first trimester.',
      },
      {
        question: 'How much amniotic fluid is normal at 13 weeks?',
        answer:
          'The normal amount of amniotic fluid at 13 weeks is around 100 ml. Other normal amounts of amniotic fluid are 60 ml at 12 weeks and 175 ml at 16 weeks.',
      },
    ],
  },
  {
    week: 14,
    header: '14 Weeks Pregnant – Welcome to the 2nd Trimester!',
    content: `
    <p>Baby’s growth is speeding up, your nausea has generally gone away & you're probably feeling ravenously hungry! It’s okay to indulge in your favorite treat from time to time, but remember that eating for two doesn't actually mean doubling your diet (I know, it feels unfair). Stay focused on getting as much nutrients as possible to keep you & baby satisfied!`,
    symptoms:
      "Aches & soreness increase as you grow You've never known hunger like this! Listen to your body & aim for nutrient dense foods to feed the needs of growing a human! If nausea, tenderness & other nasty first trimester symptoms have not gone away yet, they are likely on their way out soon!",
    yourBaby: `
    <ul>
    <li>Height: 3.5 inches</li>
    <li>Weight: 1.52 oz</li>
    <li>Facial expressions like grimacing, frowning, thumb sucking & more</li>
    <li>Organs are starting to function, & now your baby is producing urine, bile, & insulin. </li>
    <li>Growing super fine hair called lanugo that will keep body temperature regulated</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Appetite increases</li>
    <li>Energy level increases</li>
    <li>Sex drive increases</li>
    <li>Round ligament pain</li>
    <li>Varicose veins</li>
    <li>Relaxin Levels peak to help your body stretch as the fetus grows</li>
    <li>Growing body brings some aches & pains (Tip: walking is the best form of movement! Take a 10 minute walk after every meal)</li>
    </ul>
    `,
    faq: [
      {
        question: 'Can you feel the baby at 14 weeks?',
        answer:
          'It is possible but not typical to feel movement at 14 weeks. First movements of the baby are referred to as &ldquo;quickening&rdquo; and usually are not noticeable until 18-20 weeks. A first-time mom may not feel movement until even later&mdash;around 25 weeks, but moms who have previously experienced pregnancy may feel movement earlier on.',
      },
      {
        question: 'What does a baby look like at 14 weeks in the womb?',
        answer:
          'A baby&rsquo;s physical features are noticeable at 14 weeks, including arms, legs,fingers, neck and other structures. The typical length at 14 weeks is around 3 &frac12; inches with a weight of 1&frac12; ounces. Facial features are visible and facial movement is occurring due to brain impulses.',
      },
      {
        question: 'How likely is a miscarriage at 14 weeks?',
        answer:
          'Between the weeks of 13 and 20, the risk of miscarriage is around 1 percent or less.',
      },
    ],
  },
  {
    week: 15,
    header: 'Week 15 welcomes you!',
    content: `
    <p>Your baby's limbs are becoming proportional, now their legs are longer than their arms & they are movin' & groovin'. Have you felt any kicks or wiggles yet? If not, you will soon!</p>
    `,
    symptoms:
      'The hormones Progesterone & Oestrogen are on the rise to support your pregnancy! Progesterone stimulates growth of the blood vessels that supply the womb lining & Oestrogen helps the uterus grow & maintains its lining. This means some new symptoms - some GREAT, some not so fun. You may be getting a stuffed up or bloody nose thanks to increased blood flow. Heartburn & gas could show up as well. But it’s not all bad! You may find that your hair is looking luscious & vibrant, "HELLO" to your pregnancy glow! Despite the weird nosebleeds, increased energy & sex drive is a nice perk! ',
    yourBaby: `
    <ul>
    <li>Height: 4 inches</li>
    <li>Weight: 2.47 oz</li>
    <li>The skeleton is developing rapidly</li>
    <li>Legs are longer than arms</li>
    <li>All of the joints can move, & your baby is using them all</li>
    <li>Light sensitive eyes reacting to changes in lighting</li>
    <li>Ultrasound will most likely show if baby is a girl or a boy!</li>
    </ul>
    `,
    yourBody: `
    <ul>
    <li>Pregnancy Glow has entered the chat! </li>
    <li>Skin may darken in areas like the nipples & face (melasma)</li>
    <li>Runny nose, stuffy nose, nosebleeds, increased saliva</li>
    <li>Swollen & sensitive gums that may bleed easily</li>
    <li>Spider veins may appear due to increased weight</li>
    <li>Swollen feet, ankles, hands, & arms (Tip: Compression Socks & Legs up the wall)</li>
    <li>Heartburn, indigestion, constipation are common</li>
    <li>Pregnancy brain, aka: brain fog </li>
    </ul>
    `,
    faq: [
      {
        question: 'Can you feel baby move 15 weeks?',
        answer:
          'It is possible but not necessarily common to feel movement at 15 weeks. First movements of the baby are referred to as &ldquo;quickening&rdquo; and usually are not noticeable until 18-20weeks. A first-time mom may not feel movement until even later&mdash;around 25 weeks, but moms who have previously experienced pregnancy may feel movement at 15 weeks.',
      },
      {
        question: 'How should you sleep at 15 weeks pregnant?',
        answer:
          'A side sleep position is recommended during pregnancy, including the 15-week mark.Side sleeping is better for both health and comfort because it reduces pressure on the uterus and physical structures (e.g., aorta) that are needed for adequate blood supply to the baby and lower body.',
      },
      {
        question: 'What does a pregnant belly feel like at 15 weeks?',
        answer:
          'How a pregnant belly feels at 15 weeks ranges from mom to mom. Second pregnancies or twins can lead to faster growth of the belly, while others are less prominent in feeling and appearance. For some, at 15 weeks the belly begins to grow beyond the room of the pelvis and shifts upward.',
      },
      {
        question: 'Where is my baby at 15 weeks in my stomach?',
        answer:
          'The uterus and baby residing inside are around four to five inches under the belly button or about midway between the belly button and pubic bone.',
      },
    ],
  },
  {
    week: 16,
    header: 'Week Sweet 16!',
    content: `
    <p>Baby has developed tiny bones in their ears that allow them to hear sounds & will become familiar with your voice! Talk it up & start building that super special bond with your new bestie!</p>
    `,
    symptoms:
      'How’s that bump looking? In the next few weeks you can expect it to really start growing, because your baby is about to enter a serious growth spurt. You’ve got about a cup of amniotic fluid in your uterus, & combined with that baby boom & increased fluid volume you can expect to gain at least a pound a week. Now that your bump is growing you will find yourself running to the bathroom more & more!',
    yourBaby: `
    <ul>
    <li>Height: 4.5 inches</li>
    <li>Weight: 3.53 oz</li>
    <li>Entering a growth spurt, prepare for his size to double within a few weeks!</li>
    <li>Tiny bones in the Ears have developed that allow for hearing sounds</li>
    <li>Hands can grasp the umbilical cord</li>
    <li>Hair, solidified bones, eyelashes & eyebrows!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Heavy, dense feeling bump due to increase of amniotic fluid</li>
    </li>Constipation & small bladder, with your uterus pressing on your intestines its no surprise</li>
    </li>Round ligament pain</li>
    </li>Those flutters in your belly may be the baby!</li>
    </ul>
    `,
    faq: [
      {
        question: 'Can you feel the baby at 16 weeks?',
        answer:
          'It is possible to feel the baby move at 16 weeks, although some expectant women do not feel movement until around 18-20 weeks. First-time moms tend to feel movement for the first time later in pregnancy compared to second-time or beyond moms.',
      },
      {
        question: 'What to expect when you are 16 weeks pregnant?',
        answer:
          'Growth of the uterus and baby may be much more noticeable around 16 weeks pregnant, although the size of baby bump ranges at this stage of pregnancy. Generally, physical symptoms during the second trimester, including 16 weeks, are less than the first trimester, but can include breast growth, nasal congestion, backaches, vaginal discharge and constipation.',
      },
    ],
  },
  {
    week: 17,
    header: 'Welcome to week 17!',
    content: `
    <p>Baby is growing & mama is glowing! At this point, it may be hard to hide your adorable baby bump. I hope you're ready for everyone to treat you like a total princess.. as they should! And You can thank the spike in estrogen, progesterone, & prolactin for your luscious hair & perfect skin! 2nd trimester ROCKS!</p>`,
    symptoms:
      "High hormone levels & heightened anxiety is the cause of your strange dreams! Don't let them freak you out, use them to get in touch with how you're feeling. Easier said than done, we get it! But know you're not alone! Lean on your village/support system to share any concerns & make sure you're engaging in self care to eliminate stress as much as possible!",
    yourBaby: `
    <ul>
    <li>Height: 5 inches</li>
    <li>Weight: 4.94 oz</li>
    <li>Cartilage is slowly hardening into bone, creating a rigid skeleton</li>
    <li>Rapid weight gain! </li>
    <li>Fat stores developing for warmth & energy</li>
    <li>Developing sweat glands</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Skin gets thinner around fast-growing areas causing discomfort & itching  </li>
    <li>More discharge & fluids all over, as the amount of fluid in your body has greatly increased</li>
    <li>Eyes may feel dry due to hormones, but that’s an easy enough fix with some over the counter eye drops or a switch from contacts to glasses</li>
    <li>Increased appetite</li>
    <li>Round ligament pain</li>
    </ul>`,
    faq: [
      {
        question: 'Can I feel my baby at 17 weeks?',
        answer:
          'Baby movements&mdash;referred to as &ldquo;quickening&rdquo;&mdash;are likely at 17weeks of pregnancy, but not experienced by everyone. The fluttering feeling can seem like gas, but with a bit of attention, a mom can usually determine the difference over time.',
      },
      {
        question: 'Can I lay on my stomach at 17 weeks pregnant?',
        answer:
          'It is recommended to lay or sleep in a side position rather than on the stomach at 17weeks and throughout pregnancy. The side position offers pressure relief on the uterus.',
      },
    ],
  },
  {
    week: 18,
    header: 'Hello week 18!',
    content: `
    Baby is busy, finding their groove - kicking up a storm, spinning, twisting & rolling around.Baby is also yawning, hiccupping, sucking & swallowing.  You may be feeling those movements but if not, don't worry, you will soon! </p>
    `,
    symptoms:
      'As your bump grows, it may be more comfortable & safe to start sleeping on your side, rather than your back. Sleeping on your back is going to start putting extra pressure on a few major veins, something that will make you lightheaded or possibly cause lowered blood pressure. The increased work of your cardiovascular system could leave you with some varicose veins.',
    yourBaby: `
    <ul>
    <li>Height: 5.5 inches</li>
    <li>Weight: 6.70 oz</li>
    <li>Rockin’ & rollin’ inside your uterus! Expect to feel those kicks!</li>
    <li>Myelin is coating her nerves (which is essential for a functioning nervous system) & will continue to do so for a year after birth</li>
    <li>Girls’ fallopian tubes & uterus are formed & in place</li>
    <li>Boys’ genitals are noticeable by ultrasound</li>
    <li>Yawning </li>
    <li>Stretching </li>
    <li>Senses light from outside the womb</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Stronger, noticeable fetal movements </li>
    <li>Ravenous appetite - Baby is growing fast & needs nutrients! </li>
    <li>Cardiovascular system is working in overdrive (Tip: get up slowly to avoid feeling lightheadedness)</li> 
    <li>Increased leg cramping</li>
    <li>Dry eyes</li>
    <li>Be mindful of blood pressure</li>
    </ul>
    `,
    faq: [
      {
        question: 'Can you feel the baby move at 18 weeks?',
        answer:
          'Many moms feel movement for the first time between 18-20 weeks, although some may not experience movement until around 25 weeks.',
      },
      {
        question: 'How can you make your baby move?',
        answer: `There are a number of options you can try to make your baby move. Try talking to your baby, lightly wiggling your belly, increasing your blood sugar by eating healthy food and these other possible movement-motivators:
<ul><li>Jog in place or do a couple of jumping jacks before taking a seat (without straining)</li><li>Sing or play some quiet music</li><li>Lie down (the belief is continual movement can be relaxing and put a baby to    sleep)</li>
</ul>`,
      },
      {
        question: 'Where is my uterus at 18 weeks?',
        answer:
          'The uterus is located within the pelvic area and is around the size of an orange prior to pregnancy. At 18 weeks, the uterus is too big to be housed in the pelvis and instead is located about halfway between the breasts and belly button.',
      },
    ],
  },
  {
    week: 19,
    header: 'Week 19, can you feel it?',
    content:
      '<p>Sensory development week!  Specialized areas of the brain are developing to allow the five senses to fire up. Your babe may start touching the amniotic sac, reaching out & grabbing the umbilical cord, & touching their own faces!</p>',
    symptoms:
      "You are probably feeling some soreness & pains in your abdomen at 19 weeks pregnant. This is called round ligament pain & it happens as your body develops muscles to support your growing bump. Your st&ard ultrasound, a.k.a. your second trimester ultrasound, is coming up next week. If you're finding out the gender, this ultrasound will be able to confirm whether you're having a boy or girl! Be sure to tell the ultrasound tech & medical team if you're waiting to find out the gender so they don't spoil the surprise! In addition to confirming the gender, this ultrasound will ensure everything is developing on time.",
    yourBaby: `<
    <ul>
    <li>Height: 6 inches</li>
    <li>Weight: 8.47 oz</li>
    <li>Five senses are developing </li>
    <li>Arms & legs are now in the correct proportion!</li>
    <li>Growth of a protective coating over the skin, called the vernix caseosa (Vernix is latin for varnish, Caseosa is latin for… cheesy? Hey, we didn't name it!)</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Round ligament pain as the uterus expands increases</li>
    <li>More sensation, aches & pains all over, especially the abdomen, hips & back.</li>
    <li>Leg cramps (Tip: Commit to daily stretching & walks)</li>
    <li>Skin changes, especially around your face. This & darkening of the skin of your nipples, underarms & more occur as a result of hormones. If you're looking for some natural skin care products, Bump Boxes has you covered!</li>
    </ul>`,
    faq: [
      {
        question: 'How many months is 19 weeks pregnant?',
        answer:
          'A pregnancy at 19 weeks is considered the fifth month of pregnancy.',
      },
      {
        question: 'Can you feel the baby move at 19 weeks pregnant?',
        answer:
          'A baby&rsquo;s movement is commonly felt at 19 weeks pregnant, although not for everyone. Movement at 19 weeks is usually a fluttering sensation, but it is possible for an expecting mom to feel a slight kick at this stage.',
      },
      {
        question: 'What does a baby look like at 19 weeks?',
        answer:
          'At 19 weeks, a baby is around 6 inches long and weighs around 8 &frac12;&nbsp;ounces. The vernix caseosa&mdash;a greasy white protective coating&mdash;is forming to avoid skin wrinkling from the amniotic fluid. General growth continues at a speedy rate and the lungs are starting to develop at 19 weeks.',
      },
    ],
  },
  {
    week: 20,
    header: '20 Weeks Pregnant – Half Way There!',
    content: `
    <p>HALFWAY! Can you believe you hit the halfway mark? This is a huge week for you, your partner, & your bump! That combined with your 2nd trimester ultrasound makes this week a huge reason to celebrate! If you found out your baby’s sex, suddenly you can start to imagine your little boy or girl more vividly. And if you didn't, you're inching toward the surprise of your life. That’s some pretty strong motivation no matter what you decide!</p>
    <p>At 20 weeks pregnant, baby is 6.5 inches long (crown to rump), 10 inches long (crown to heel) & 10.5 ounces in weight. That’s right, at week 20 babies make the switch to being measured head to toe. Yet another sign of progress! Speaking of measuring, your provider will be sizing up your uterus at every visit from now on. Your uterus is about belly-button height, & will start to grow upward at a rate of one centimeter weekly.</p>
    <p>Hang in there, mama & be sure to treat yourself to some self care. You deserve it!</p>`,
    symptoms: 
      "More of the same, mama! The aches, pains, swelling, indigestion, bleeding gums, fatigue & strong appetite seem normal at this point. If you're experiencing any unusual or concerning symptoms, such as severe pain, bleeding or fever, make sure you contact your care team immediately. Most importantly, commit time to self care & do things that make you feel good!More of the same, mama! The aches, pains, swelling, indigestion, bleeding gums, fatigue & strong appetite seem normal at this point. If you're experiencing any unusual or concerning symptoms, such as severe pain, bleeding or fever, make sure you contact your care team immediately. Most importantly, commit time to self care & do things that make you feel good!",
    yourBaby: `
    <ul>
    <li>Measured crown to heel now that the limbs are developed enough</li>
     <li>Swallowing amniotic fluid, a good workout for a new digestive system</li>
     <li>All of your antibodies are being transferred to build up baby’s immune system</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Vaginal discharge that will continue until delivery</li>
     <li>Heartburn, stomach aches, shortness of breath as your growing uterus presses on your organs</li>
     <li>High energy & a major psychological boost</li>
     <li>Leg cramps</li>
     <li>Aches & pains</li>
    </ul>
    `,
    faq: [
      {
        question: 'Can you feel the baby move at 20 weeks?',
        answer:
          'Many expecting moms experience the baby&rsquo;s first movements between 18-20 weeks.These movements can feel similar to gas and are described as a fluttering sensation.',
      },
      {
        question: 'How can I make my baby move at 20 weeks?',
        answer: `There are a number of ways to try and make a baby move at 20 weeks. Among the options are:
    <ul><li>Try talking to your baby</li><li>Lightly wiggle your belly</li><li>Eat healthy food (increased blood sugar from eating might motivate a baby to    move)</li><li>Jog in place or do a couple of jumping jacks before sitting down (without    straining)</li><li>Sing or play quiet music</li><li>Lie down (the belief is continual movement can be relaxing and put a baby to    sleep)</li>
    </ul>`,
      },
      {
        question: 'What can I expect at my 20 week ultrasound?',
        answer:
          'The 20-week ultrasound is a comprehensive view to check the development of the baby and mom. All physical structures are reviewed, such as the brain, spine, heart and limbs, as well as a measurement of the baby&rsquo;s overall growth. Mom&rsquo;s internal structures&mdash;uterus and placenta&mdash;and the amniotic fluid are also assessed. Sex of the baby can typically be determined at the20-week ultrasound.',
      },
    ],
  },
  {
    week: 21,
    header: 'Week 21, lets have some fun!',
    content: `
    <p>Some women claim that they feel more energetic & all around awesome at this stage of pregnancy than ever before, even outside of pregnancy. We hope you're one of them!</p>
    <p>Your baby is busy packing on the pounds - getting nutrients & hydrated from drinking a bunch of amniotic fluid. A substance called meconium is being manufactured in their intestines. That’s some tarry, black stuff that is a byproduct of an early digestive system, & you will get familiar with it the first time you change your baby’s diaper. Your baby’s little kicks & punches should be really noticeable by now, they are just as excited for their birthday as you are!</p>`,
    symptoms:
      'Your body is preparing for babies arrival, which means you may start to experience leaky breasts & Braxton Hicks contractions. The hallmark of those contractions is a particular tightness in the uterus, it’s a sign your body’s getting ready for delivery. Some other symptoms include varicose veins & spider veins (not as scary as they sound!) on your ankles, legs or other places. These are caused by an increase of blood flow & progesterone, & can be minimized by daily exercise, wearing compression socks & putting your feet up.',
    yourBaby: `
    <ul>
    <li>Height: 6.5 inches</li>
    <li>Weight: 10.58 oz</li>
    <li>Taste buds develop</li>
    <li>Digestive system starts working & producing meconium</li>
   <li> Respiration systems are getting prepped for the outside world</li>
    <li>The eyelids are still sealed, but the eyes are as active as the limbs</li>
    <li>Girls have developed a lifetime supply of eggs (over six million) already!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Energy - Keep moving & do the things you enjoy most with the people you love!</li>
    <li>Heartburn or indigestion</li>
    <li>Leg cramps</li>
    <li>Aches & pains</li>
    <li>Hair & nails are growing like crazy</li>
    <li>Sex drive increases</li>
    <li>Belly is growing fast, stretch marks & itchiness on areas tend to grow just as quickly</li>
    </ul>
    `,
    faq: [
      {
        question: 'How many months is 21 weeks pregnant?',
        answer: 'A pregnancy at 21 weeks is considered in the fifth month.',
      },
      {
        question: 'Where is the uterus at 21 weeks?',
        answer:
          'The location of the uterus is above the pelvis&mdash;around a half-inch above the bellybutton.',
      },
    ],
  },
  {
    week: 22,
    header: 'Here’s to you, week 22!',
    content: `
    <p>Baby is going to start packing on the pounds. You’ve been gaining about a pound every week until now, & that should slow down to a half-pound weekly. With your belly growing so much at such a crazy speed, you are likely to see some stretch marks & experience itching. You may even start to get an “outie” belly button!</p>
    <p>Baby’s eyes & lips are much more developed, looking like a tiny version of a newborn! This week, babe is busy growing their pancreas & working on a layer of fat to keep them warm. You may notice your baby isn't kicking or moving a whole bunch for about 14 hours a day. No worries, they're just sleeping!</p>`,
    symptoms:
      "Your hormones, oh how you’ve grown to love them, are still running wild. This results in a variety of outcomes, from hair growing where it usually doesn't grow, to a super increased sex drive. It will be different acting on your libido than it is outside of pregnancy. That’s why communication – with your partner, your support team & your care provider – is key!",
    yourBaby: `
    <ul>
    <li>Height: 10.94 inches</li>
    <li>Weight: 15.17 oz</li>
    <li>Highest priority - pack on as much weight as possible until birth!</li>
    <li>New teeth & developing lips</li>
    <li>Eyelids & eyebrows are fully formed.</li>
    </ul>
    `,
    yourBody: `
    <ul>
    <li>Your ever-increasing uterus is likely causing frequent urination, shortness of breath, & back aches</li>
    <li>More vaginal discharge</li>
    <li>Swollen feet & hands</li>
    <li>Heartburn or indigestion</li>
    <li>Leg cramps</li>
    <li>Aches & pains</li>
    <li>Acne</li>
    <li>Outie belly button</li>
    <li>Hot flashes</li>
    <li>Heart rate increases</li>
    </ul>
    `,
    faq: [
      {
        question: 'Can a baby born at 22 weeks survive?',
        answer:
          'It is difficult for a baby born at 22 weeks to survive due to underdeveloped organs like the lungs.',
      },
      {
        question: 'How many months is 22 weeks pregnant?',
        answer:
          'The 22-week mark of pregnancy is within the fifth&nbsp;<span>month.',
      },
      {
        question: 'Are headaches normal at 22 weeks pregnant?',
        answer:
          'Headaches are not viewed as a normal part of pregnancy at 22 weeks. Factors such as dehydration can be the cause, but headaches can also be a symptom of more serious causes, such as preeclampsia. Contact a medical professional to determine the reason for a headache at 22 weeks pregnant.',
      },
    ],
  },
  {
    week: 23,
    header: 'What do you think about week 23?',
    content: `
    <p>Baby is familiar with your voice, & accustomed to the big noises in your life such as cars honking & dogs barking. They are also a pro at sensing movement, so when you're dancing to your favorite song he is having just as much fun as you!</p>`,
    symptoms:
      'You may start feeling some Braxton Hicks contractions (just your body preparing for delivery) & swelling...oh the swelling. Try to keep moving around & staying hydrated!',
    yourBaby: `
    <ul>
    <li>Height: 11 inches</li>
    <li>Weight: 1.10 lb</li>
    <li>Fully formed face</li>
    <li>Skin is wrinkly but filling out with fat</li>
    <li>Sense of hearing has developed to allow baby to get familiar with the world beyond the womb</li>
    <li>Blood vessels in the lungs are growing & getting ready to breathe</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Swollen ankles & feet. This is caused by fluid retention, stay hydrated to combat</li>
    <li>Braxton Hicks contractions may begin, preparing you for delivery</li>
    <li>Heartburn or indigestion</li>
    <li>Leg cramps</li>
    <li>Aches & pains</li>
    <li>Urination increases</li>
    <li>Leaky nipples</li>
    <li>Darker nipples</li>
    <li>Cravings</li>
    </ul>
    `,
    faq: [
      {
        question: 'How many months is 23 weeks pregnant?',
        answer:
          'At 23 weeks pregnant, a woman is in her sixth&nbsp;<span>month of pregnancy.',
      },
      {
        question: 'What should I be eating at 23 weeks pregnant?',
        answer: `Guidelines about what to eat and not to eat during pregnancy&mdash;including at 23 weeks&mdash;focus on avoiding potential toxins like mercury and ensuring a diet is balanced and includes important nutritional components for healthy development. Healthy foods for pregnancy can include:
<ul><li>Eggs</li><li>Leafy greens</li><li>Sweet potatoes</li><li>Nuts</li><li>Mangoes</li><li>Beans </li><li>Lentils</li><li>Avocadoes</li><li>Oatmeal</li><li>Lean meat</li><li>Yogurt</li>
</ul> Talk with your healthcare provider to determine the healthy foods that fit your individual pregnancy experience.`,
      },
      {
        question: 'Can a baby be born at 23 weeks and survive?',
        answer:
          'A baby born at 23 weeks can survive, although underdevelopment of organs such as the lungs and other complications of preterm birth can still affect the likelihood of surviving at 23 weeks. Birth that occurs before 37 weeks is considered preterm.',
      },
    ],
  },
  {
    week: 24,
    header: '',
    content: `
    <p>Up until now, your baby has had mostly see-through skin. At 24 weeks pregnant, her skin will start to develop pigment & become more opaque. They are looking cuter every day! Within their skin, their lungs are developed for breathing fresh air. Just another step closer to life in the outside world.</p>`,
    symptoms:
      "By now, your uterus is about the size of soccer ball aka flaunt that bump! Tons of brain cells & exciting developments are happening right now. Heartburn is probably still hanging out around & you're most likely gearing up for your Glucose Tolerance Test. You should be feeling a lot of movement in there, especially since baby is starting to react to outside light, sounds & touch with her fearsome kicks! Hi-yah!",
    yourBaby: `
    <ul>
    <li>Height: 11.8 inches</li>
    <li>Weight: 1.32 lb</li>
    <li>Fast developing brain & lungs</li>
    <li>Lungs start producing surfactant, necessary for breathing after birth</li>
    <li>Skin is becoming less transparent & more pink due to pigment</li>
    <li>Tons of "kicks" – although they are called kicks, they could be anything from regular movement to hiccups!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Heartburn or indigestion</li>
    <li>Leg cramps</li>
    <li>Aches & pains</li>
    <li>Urination increases</li>
    <li>Leaky nipples</li>
    <li>Darker nipples</li>
    <li>Cravings</li>
    </ul>
    `,
    faq: [
      {
        question: 'Are babies fully developed at 24 weeks?',
        answer:
          'Babies are not fully developed at 24 weeks. Lung and bone marrow development are among the physical maturation continuing at 24 weeks.',
      },
      {
        question: 'How many months is 24 weeks pregnant?',
        answer:
          'An expectant mom who is 24 weeks pregnant is in her sixth<span>&nbsp;month of pregnancy.',
      },
      {
        question: 'What position is the baby in at 24 weeks?',
        answer:
          'A baby is likely in a transverse or sideways position at 24 weeks, although other positions are possible.',
      },
      {
        question: 'How often should you feel your baby move at 24 weeks?',
        answer:
          'Increased movement occurs as pregnancy continues, but some moms don&rsquo;t feel movement for the first time until 25 weeks. Once movement is first felt, it is important to pay attention to ongoing movement. By the third trimester, a mom should feel around 30 movements each hour.',
      },
    ],
  },
  {
    week: 25,
    header: 'Feeling alive in week 25!',
    content: `
    <p>Baby's weight has doubled since last month, & will double & triple during the coming trimester. That’s one heck of a growth spurt!</p>
    <p>Now that baby has gotten so big, if your partner listens close to your belly, a tiny heartbeat can be heard! Baby’s skin is smoothing out & becoming more opaque & pink, just like a newborn’s. And their hair (real hair, not lanugo) is growing out & developing color & texture. Adorable!</p>`,
    symptoms:
      "Constipation is common as baby has started to put some pressure on your digestive tract so getting in some extra fiber might be a good idea. You'll also need to pee ALL. THE. TIME. because baby is pressing on your bladder. You may also have some trouble sleeping, either due to hormones, that big bump getting in the way, all of the peeing or the anxiety that comes with the thought 'I'm getting pretty close to delivering this baby!'",
    yourBaby: `
    <ul>
    <li>Height: 13.6 inches</li>
    <li>Weight: 1.46 lb</li>
    <li>Recognize familiar voices</li>
    <li>Growing steady, & working on a layer of fat to stay warm</li>
    <li>Nostrils that used to be plugged up are now open for business</li>
    <li> Nimble fingers & hands allow your baby to touch his feet & make a fist</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Constipation</li>
    <li>Heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Need to PEE!</li>
    <li>Leaky nipples</li>
    <li>Darker nipples</li>
    <li>Clumsiness </li>
    <li>Shortness of breath as the uterus presses on the lungs.</li>
    <li>Feeling the burn from muscle & back aches? Try some swimming, walking, yoga, & any other non-weight-bearing exercise. </li>
    </ul>
    `,
    faq: [
      {
        question: 'Is 25 weeks the 3rd trimester?',
        answer:
          'No, 25 weeks is not the third trimester. The third trimester begins at 27 weeks.',
      },
      {
        question: 'What month is week 25 of pregnancy?',
        answer: 'Week 25 is the sixth month of pregnancy.',
      },
    ],
  },
  {
    week: 26,
    header: 'Week 26 says hello!',
    content: `
    <p>Baby has started developing some luscious eyelashes & eye color. Up until right now, your baby’s eyelids have been fused shut as they develop. This week, they're opening up & letting the light in! What color do you think they will be? No matter what the genetics are, babies all have blue eyes in the womb & at birth. they'll darken from blue within a few months!</p>
    <p>Your bump keeps growing & getting heavier. Braxton Hicks symptoms could be real right about now along with some elevated stress so try to take it easy, go for some walks, & maybe even tryout a yoga class!</p>
`,
    symptoms:
      'Pregnancy brain is heightened & you may start to feel forgetful…its a real symptom, not just you! These are all totally natural for pregnancy. It would happen to anyone going through such a major change (even without the raging hormones), so hang in there!',
    yourBaby: `
    <ul>
    <li>Height: 14 inches </li>
    <li>Weight: 1.68 lb</li>
    <li>Eyes are opening</li>
    <li>Eyelashes are growing</li>
    <li>Immune system is building up</li>
    <li>Breathing in amniotic fluid, great rehearsal for the real deal</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Achy back, due to hormonal changes & that big bump you’ve been carrying around</li>
    <li>Braxton Hicks contractions. Feel that tightness in your belly every now & again? don't worry, your body is just getting prepared for labor</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Clumsiness </li>
    <li>Did we mention, forgetfulness? </li>
    </ul>`,
    faq: [
      {
        question: 'What position is the baby in at 26 weeks?',
        answer:
          'At 26 weeks a baby is likely in the transverse sideways position, but can begin to shift to the vertical position, meaning the head or rear faces downward.',
      },
      {
        question: 'How many months is 26 weeks pregnant?',
        answer: 'Week 26 is the sixth month of pregnancy.',
      },
      {
        question: 'Is third trimester at 26 weeks?',
        answer:
          'No, 26 weeks is not the third trimester. The third trimester begins at 27weeks.',
      },
      {
        question: 'How much weight should I have gained at 26 weeks pregnant?',
        answer:
          'Weight gain at 26 weeks of pregnancy should range between 16 and 22 pounds.',
      },
    ],
  },
  {
    week: 27,
    header: 'Is it week 27 already?',
    content: `
    <p>baby’s brain activity is going off the charts. His brain activity is getting more & more complex every day now. The brain stem – the part of the brain responsible for our most vital functions – has come close to becoming fully developed. This is cool because it means if your baby were born now he would actually have an 85 percent chance of surviving because all of his vitals are present & accounted for! Of course there’s still a lot more growing left to do before the big day!</p>
    `,
    symptoms:
      "As you approach the final trimester, you will start to experience symptoms that are slightly different than what you're used to. You are familiar with stretch marks, which will likely make their appearance soon if they haven't already. Those leg cramps will get pretty annoying, & so will that shrinking bladder. In fact, with such a big, well-developed baby sitting right on your bladder, don't be surprised if you experience a little extra leaking every now & again! (Yikes!) You’ve just reached the beginning of the end, & that big delivery date is growing on the horizon every day.",
    yourBaby: `
    <ul>
    <li>Height: 14.41 inches </li>
    <li> Weight: 1.93 lb </li>
    <li>Fully developed brain stem means that your baby is fully equipped for life outside the womb! </li>
    <li>Practicing inhaling & exhaling amniotic fluid & strengthening young lungs </li>
    <li>Amniotic fluid is decreasing, you may be able to see tiny knees & elbows poking your belly </li>
    </ul>
    `,
    yourBody: `
        <ul>
    <li>Shooting pain in your lower back & legs (ouch!) TIP: take warm baths or use ice packs on tension </li>
   <li> Constipation, heartburn or indigestion </li>
    <li>Constant urination  </li>
    <li>Round ligament pain </li>
    <li>Mood swings </li>
    <li>Increased blood pressure </li>
    <li>Braxton hicks </li>
    <li>Restless leg syndrome </li>
    </ul>`,
    faq: [
      {
        question: 'Is 27 weeks third trimester?',
        answer: 'Yes, 27 weeks marks the beginning of the third trimester.',
      },
      {
        question: 'What position is baby in at 27 weeks?',
        answer:
          'Babies often start to shift in position around 27 weeks, from the transverse sideways position to the vertical position, with either the head or rear facing downward.',
      },
      {
        question: 'How many months is 27 weeks pregnant?',
        answer: 'Week 27 is in the sixth month of pregnancy.',
      },
      {
        question: 'How can I make my baby move at 27 weeks?',
        answer: `There are a number of ways to try and make a baby move at 27 weeks. Among the options are:
<ul><li>Try talking to your baby (babies can hear and recognize sounds at this    stage)</li><li>Lightly wiggle your belly</li><li>Eat healthy food (increased blood sugar from eating might motivate a baby to    move)</li><li>Jog in place or do a couple of jumping jacks before sitting down (without    straining)</li><li>Sing or play quiet music</li><li>Lie down (the belief is continual movement can be relaxing and put a baby to    sleep)</li>
</ul>`,
      },
    ],
  },
  {
    week: 28,
    header: '28 Weeks Pregnant – Welcome to the Third Trimester!',
    content: `
    <p>Hello, Third Trimester! </p>
    <p>A lot of moms at this stage find themselves missing out on sleep. The leg cramps can start to drive you nuts at night! That bump, bigger every day, is pretty tough to ignore when you're trying to get comfortable. Even more, your baby has gotten big enough to give you some real “Wake Up!” kicks. That won't be the last time they mess with your beauty sleep. Either way, hormones, nerves & everything else that keeps you up at night is nicely treated with a hot beverage, relaxing music & a nice blanket. Stay relaxed, you'll thank yourself!</p>
    <p>Baby’s big plan for this week involves finishing off work on vital organs, building up the brain, & growing layers of fat. As more fat develops, baby’s skin becomes less wrinkly & much more smooth & more like, well, a baby. Their brain will also do some serious growth – from the start of the 3rd trimester until birth, baby’s brains grow 400-500 percent in weight. Baby genius!</p>`,
    symptoms:
      'In the 3rd trimester you & baby are just about ready to go. You & baby are nearly ready for delivery. Your breasts are producing (& sometimes leaking) colostrum; a yellowish, antibody-rich substance that is going to be what baby eats for the first few days. Those Braxton Hicks contractions are preparing your muscles for labor. ',
    yourBaby: `
    <ul>
    <li>Height: 14.8 inches</li>
    <li>Weight: 2.22 lb</li>
    <li>Rapid brain development </li>
    <li>Baby starts dreaming (REM sleep).</li>
    <li>Blinking those big eyes, which are now adorned with beautiful eyelashes</li>
    <li>Maturing lungs are getting practice for air by hiccupping</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains, especially in your legs!</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'What position is the baby in at 28 weeks?',
        answer:
          'Around 28 weeks babies tend to shift from the transverse sideways position to a vertical position with the head or rear positioned downward',
      },
      {
        question: 'Can you deliver a baby at 28 weeks?',
        answer:
          'A baby can be delivered and survive at 28 weeks. Significant medical attention will be needed to sustain a preterm baby&rsquo;s development after early delivery.',
      },
      {
        question: 'How often should you feel your baby move at 28 weeks?',
        answer:
          'It is recommended to start counting movement at 28 weeks to get an idea of normal movement for your baby. Contact a medical professional if you notice changes from your baby&rsquo;s normal movement. During a time when a baby is typically active, keep track of how long it takes for your baby to move 10 times (within two hours is the expectation).',
      },
    ],
  },
  {
    week: 29,
    header: 'Week 29, feelin’ fine!',
    content: `
    <p>Baby 9is very active, but you probably found that out pretty easily in between the kicks & jabs! Your care provider may ask you to spend a few minutes a day counting those kicks, which can be a fun little way to bond with your baby.</p>
    <p>Your baby has been working out those little muscles a lot lately! Their bones are growing too, & they're going to need a steady supply of calcium as they strengthen & harden. Baby needs a lot of nutrients now, so be sure to help his growth by taking in plenty of Vitamin C, Protein, Folic Acid, Calcium & Iron. On top of nutrition, you should also work on a little exercise whenever you can. Exercise is always helpful, & during pregnancy it will help you get through labor & recovery</p>`,
    symptoms:
      'As the 3rd trimester kicks into gear, you are probably noticing a bunch of crazy symptoms. At 29 weeks pregnant, most of these will be related to your uterus crowding your digestive system. Most mommies who are 29 weeks pregnant report constipation, heartburn, & even hemorrhoids. Ouch! Be sure to eat plenty of fiber to help combat these nasty symptoms. You are probably getting well acquainted with back, leg & pelvic pain by now. And to top it all off, leaky breasts, varicose veins & the super frequent urge to pee! Yeesh! Nobody said it was going to be easy, but this is all a bit much. Just be sure to eat at regular intervals to keep your blood sugar up, & get plenty of sleep. Your body needs as much rest as it can get.',
    yourBaby: `
    <ul>
    <li>Height: 15.2 inches </li>
    <li>Weight: 2.54 lb</li>
    <li>Developing a layer of white fat which will keep their body temperature regulated</li>
    <li>Adrenal glands are producing estriol, a chemical that tells your body to produce milk & lactate</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Your uterus is crowding your digestive tract – namely heartburn, constipation & hemorrhoids</li>
    <li>Sleep can be tough - take that midday nap if you need it!</li>
    <li>Headaches & dizziness! Eat regularly to keep your blood sugar regulated</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'What position is the baby in at 29 weeks?',
        answer:
          'A baby is typically in a vertical position with the head or rear facing downward.Ideally, the baby will move to a head down position. &nbsp;',
      },
      {
        question: 'How many months is 29 weeks pregnant?',
        answer:
          'An expecting mom in her 29t h week is also in her seventh&nbsp;month of pregnancy.',
      },
      {
        question: 'Can a baby born at 29 weeks survive?',
        answer:
          'A baby born at 29 weeks can survive, but will need significant medical attention for continued development, such as maturation of the lungs.',
      },
      {
        question: 'How much weight should I have gained at 29 weeks?',
        answer:
          'Pregnancy weight gain at 29 weeks ranges between 19 and 25 pounds.',
      },
    ],
  },
  {
    week: 30,
    header: '30 Weeks Pregnant – 10 Weeks Until the Big Day!',
    content: `
    <p>10 weeks until your due date! Did you know that your baby has doubled in length in the last six weeks?</p>
    <p>baby’s eyesight develops the ability to track light. Some researchers believe that shining light on your belly at this stage may actually stimulate development, so go grab a flashlight & see if she reacts! Another very cool change this week is that baby’s skin is getting smoother but her brain is getting more wrinkly. The wrinkles create more surface area for neural connections to form, allowing (later down the road) complex thought.</p>
    <p>Feeling a little nervous about the big day? It’s perfectly natural for mommies to wonder about their delivery or if they will be a good parent or not. There is a lot of anxiety associated with this stage that can really throw you off your game. Try doing little things to ease your worries, like taking a test drive to the hospital. The extra peace of mind is well worth the trip!</p>`,
    symptoms:
      'You’ve gotten bigger & your belly is the size of a watermelon! Hoisting around this growing belly is tough work, & now it may even start to be tricky just to tie your shoes. In fact, hormones create looseness in your joints & ligaments, which can cause your feet to spread & grow another size or so permanently. All this on top of a very offset center of balance can make you start to feel a bit clumsy!',
    yourBaby: `
    <ul>
    <li>Height: 15.71 inches</li>
    <li>Weight: 2.91 lb</li>
    <li>Strong enough to grip a finger</li>
    <li>Swimming in 1 ½ pints of amniotic fluid, & less every day as she grows</li>
    <li>Light sensitive eyes, hello sunshine!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Different factors contributing to a lack of balance & newfound clumsiness</li>
    <li>Bigger feet attached to your cramped legs</li>
    <li>Pelvic pressure is on the rise</li>
    <li>Anxious! There’s a lot to worry about, don't let it all consume your thoughts</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li> Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li> Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is your baby fully developed at 30 weeks?',
        answer:
          'A baby is not fully developed at 30 weeks. Continued weight gain and maturation of the digestive system and lungs are examples of development still taking place at 30 weeks.',
      },
      {
        question: 'Is baby head down at 30 weeks?',
        answer:
          'Babies often move to a vertical position with the head down around 30 weeks.',
      },
      {
        question: 'Why are you so tired in your third trimester?',
        answer:
          'Feeling tired in the third trimester can be due to a few factors. Weight gain that occurs throughout pregnancy and having to carry the extra weight over time can be fatiguing. Other contributors are sleep difficulties and frequent urination (which can disrupt sleep).',
      },
    ],
  },
  {
    week: 31,
    header: 'Week 31, tons of fun!',
    content: `
    <p>Have you started wondering if there's any way you could get any bigger?! There is! Pregnancy is truly amazing!</p>
    <p>By now, your baby can use all five senses! HUGE step in development.</p>
    <p>Hips hurting a little? Boobs leaking a little? Feet hurt? All in due time, Mama. All your hard work will pay in the cutest reward!</p>`,
    symptoms:
      "Baby is having the time of his life throwing his newfound weight around. As they get bigger & runs out of wiggle room in the uterus, their activity is going to be a lot more noticeable. Some doctors will ask moms to spend some time counting kicks, or keep a kick chart, to measure baby’s activity. If baby starts slacking or slowing their movement down a noticeable amount & it’s starting to scare you, try a big glass of cold juice to spur his energy. If that doesn't seem to work, contact your care provider. Its common to feel tightening of your uterus at random intervals, which are Braxton Hicks contractions. They typically last 30 seconds or so a piece. Though they're not actually the start of going into labor, you should contact your provider if you feel more than four contractions in an hour. It could be a sign of preterm labor.",
    yourBaby: `
    <ul>
    <li>Height: 16.18 inches</li>
    <li>Weight: 3.31 lb</li>
    <li>Five senses are fully developed</li>
    <li>Fat is accumulating under the skin & sculpting the perfect chubby cheeks!</li>
    <li>Very active, on average delivering ten kicks per hour</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Shortness of breath from increased pressure on the lungs</li>
    <li>Constant need to pee! Say goodbye to sleeping through the whole night!</li>
    <li>Colostrum (pre milk) leaking from your breasts. Get some nursing pads to save those bras!</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is baby fully developed at 31 weeks?',
        answer:
          'A baby is not fully developed at 31 weeks. Never and brain development are continuing at 31 weeks, along with other important growth markers.',
      },
      {
        question: 'How can you tell if your baby has dropped?',
        answer:
          'The indicators that your baby has dropped can include pelvic discomfort, increased pelvic pressure, more than usual discharge, even more frequent urination and reduced weight on the diaphragm that results in improved breathing.',
      },
      {
        question: 'Is the baby head down at 31 weeks?',
        answer: 'A baby&rsquo;s head is typically positioned down at 31 weeks.',
      },
    ],
  },
  {
    week: 32,
    header: 'Week 32, how do you do?',
    content: `
    <p>Eight weeks out & baby is already getting ready for the big day – at this time baby has flipped into the head down position & is ready for their descent. As they gets into position for their passage through the birth canal, your nipples are leaking colostrum & darkening. If your baby were born right now, they'd be able to see your nipples for breastfeeding. Your baby is so close to being fully developed that all they need is more weight. A preterm birth at 32 weeks pregnant would actually lead to very few complications & baby would have an extraordinary high chance of survival.
    `,
    symptoms:
      "Nesting is at its peak, preparing your environment for when baby arrives. We’re talking anything from getting the crib set up, to stockpiling diapers, to preparing & freezing dinners for the next two weeks. We recommend setting up a list & a hospital bag. It’s gratifying to add & cross off items from the list, & keeping the bag by the door will really add a sense of preparedness that will ward off anxiety! And while you're in the cleaning spirit, be sure to only use products that are free of dangerous chemicals.",
    yourBaby: `
    <ul>
    <li>Height: 16.19 inches</li>
     <li>Weight: 3.75 lb</li>
     <li>Moves into head down position</li>
     <li>Losing their coat of lanugo (infant body hair)</li>
     <li>REM (dream producing!) sleep is occurring</li>
     <li>Practicing breathingHeight: 16.19 inches Weight: 3.75 lb</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Increased Braxton Hicks contractions</li>
     <li>Vaginal discharge – your body is preparing for labor & using this to prevent infection</li>
     <li>With so much to think about, so many kung-fu kicks from baby & such a tiny bladder, a full night of sleep is a rare thing</li>
     <li>Insomnia / Difficulty Sleeping</li>
     <li>Constipation, heartburn or indigestion</li>
     <li>Aches & pains</li>
     <li>Constant urination </li>
     <li>Round ligament pain</li>
     <li>Mood swings</li>
     <li>Increased blood pressure</li>
     <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'How many months is 32 weeks pregnant?',
        answer:
          'At 32 weeks, a woman is in her eighth&nbsp;<span>month of pregnancy.',
      },
      {
        question: 'Are babies fully developed at 32 weeks?',
        answer:
          'A baby is not fully developed at 32 weeks. Lungs are still developing at 32weeks.',
      },
    ],
  },
  {
    week: 33,
    header: 'Here’s to week 33!',
    content: `
    <p>Your baby is now in the head-down position & at some point in the next six weeks they will descend into your pelvis. This is their final preparation for birth, & what’s double cool about it is that the position allows a ton of much needed blood to flow to their brain & fuel growth. Besides flipping perspective, baby’s bones are also starting to harden. The skull will remain soft, & some of the bones up there will in fact overlap a bit in order to ease the passage through the birth canal. They won't fuse all the way until they are a young adult, their brain is going to exp& a lot before then!</p>`,
    symptoms:
      "After 33 weeks pregnant you may be a little sick of the whole pregnancy thing. That’s understandable! Just remember, when you find yourself wishing this baby were born already: he’s much easier to take care of inside you than out. It may not seem that easy during these next few weeks, though. you're likely suffering a lot of forgetfulness with so much on your mind (& don't forget the hormones), as well as an added helping of clumsiness due to your new size. One very special symptom you'll notice now is a feeling that you're overheating. Your metabolism is working at turbo speed, so you're probably sweating as you read this. ",
    yourBaby: `
    <ul>
    <li>Height: 17.2 inches</li>
    <li>Weight: 4.23 lb</li>
    <li>Bones are hardening but the skull will remain soft</li>
    <li>Immune system strengthens</li>
    <li>Eyes are open while awake</li>
    <li>More & more brain development </li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Hot hot hot! Your metabolic rate is at an all-time high, & you're feeling like you're cooking as a result</li>
    <li>Numbness in fingers, wrists & hands. Be sure to stretch your hands out if you do a lot of repetitive tasks with them</li>
    <li>Swollen feet, fatigue, & back pain intensify</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Can you have a baby at 33 weeks?',
        answer:
          'A baby can be delivered and survive at 33 weeks, although it is considered a pre term birth prior to 37 weeks. Medical attention can help additional growth and development needed for a pre term baby.',
      },
      {
        question: 'What position is the baby in at 33 weeks?',
        answer:
          'The position of most babies at 33 weeks is a vertical position with the head facing downward.',
      },
      {
        question: 'What week does the baby drop?',
        answer:
          'There is variation in when and even if a baby will drop. First-time moms may feel the baby drop somewhere between two and four weeks prior to birth. Second and beyond moms may not experience a baby drop. Factors such as how low or high an expecting mom is carrying can affect the likelihood of feeling the baby drop.',
      },
      {
        question: 'How can you tell if your baby has dropped?',
        answer:
          'The indicators that your baby has dropped can include pelvic discomfort, increased pelvic pressure, more than usual discharge, even more frequent urination and reduced weight on the diaphragm that results in improved breathing.',
      },
    ],
  },
  {
    week: 34,
    header: 'Here you are, week 34!',
    content: `
    <p>Your baby can hear a lot more clearly now & can even recognize songs. Some researchers believe that if you sing songs to your baby now, they will be more soothed by them when they hear them from you after being born. They will definitely be familiar with your voice though, & has already formed an attachment to it. Play her a tune or sing a lullaby!</p>
    <p>When you're 34 weeks pregnant, baby is piling on the fat, making their skin baby soft! Your body has been boosting your immunity & pumping antibodies to your baby to give her a strong immune system when they makes their debut. In case you're worried about preterm delivery, babies born during this week & later usually have no long-term health problems & end up generally healthy & complication-free. That’s a relief!</p>`,
    symptoms:
      "Speaking of relief, at some point in the near future (any time between now & the day of delivery, actually) your baby will descend into your pelvis. That will make breathing a lot easier, but the tradeoff is that your bladder will be even more squished than ever. And you thought you took a lot of bathroom breaks now! You are probably getting familiar with your symptoms by now – swollen feet, legs & lower back cramps, constipation & lack of sleep to name a few – but soon you may experience a few more. At 34 weeks pregnant, some mommies report blurred vision as a result of everybody’s favorite troublemaker, hormones. Others get these itchy red bumps along their stomach, thighs & buttocks called “pruritic urticarial papules & plaques of pregnancy” – PUPPP for short! If you are noticing PUPPP, talk to your provider & they'll help you out!",
    yourBaby: `
    <ul>
    <li>Height: 17.72 inches </li>
    <li>Weight: 4.73 lb</li>
    <li>Lungs are nearly fully mature</li>
    <li>Reacting to sounds more than ever, & recognizing music for the very first time</li>
    <li>Taking deep breaths of amniotic fluid</li>
    <li>Getting into position for birth, preparing to make their descent</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Swollen feet, constipation, hemorrhoids, headaches, & cramps – not fun!</li>
    <li>Blurry vision, & the possibility of PUPPP (itchy little red bumps)</li>
    <li>Hardly any sleep. Mommies need rest, so get as much as you can no matter how many late night bathroom trips you need to make!</li>
    <li>Leaking colostrum (early breast milk, AKA liquid GOLD) is common</li>
    </ul>`,
    faq: [
      {
        question: 'Is it safe to deliver at 34 weeks?',
        answer:
          'A delivery at 34 weeks is considered preterm and although it is safer than earlier weeks, medical attention will still be likely. A baby&rsquo;s development is not complete at 34weeks.',
      },
      {
        question: 'What week of pregnancy is the baby fully developed?',
        answer:
          'Pregnancies that go beyond week 39 are viewed as full term pregnancies, or the week mark when the baby is typically fully developed.',
      },
      {
        question: 'How many months is 34 weeks pregnant?',
        answer: 'At 34 weeks, a woman has been pregnant for eight months.',
      },
    ],
  },
  {
    week: 35,
    header: '35 Weeks Pregnant – 5 Weeks Until The Due Date!',
    content: `
    <p>Some systems need to mature, but everything is fully put together. If baby were born today, they would have a 90% chance of survival. Wow! Your baby isn't going to get much taller but the weight will still be getting packed on. You'll be able to squeeze that adorable baby fat so soon!</p>
    <p>At 35 weeks pregnant, you are feeling it! Your uterus is crowded! Feeling constipated & heartburn? You're almost there!</p>`,
    symptoms:
      "Baby isn't the only one getting bigger! You can expect to gain a half-pound per week up until delivery. you're probably feeling like you’ve blown up over the past few months. Well, you kind of have! Here’s something crazy – your uterus has grown to over 1,000 times its original size since conception, & there’s still more to come!",
    yourBaby: `
    <ul>
    <li>Height: 18.19 inches </li>
    <li>Weight: 5.25 lb</li>
    <li>Majority of lanugo (downy body hair) has been shed now that baby has a layer of fat to keep them warm</li>
    <li>Boys testes have most likely descended</li>
    <li>Physical development that goes on in the womb has happened! Now it’s a race to put on weight before the big day</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>If it hasn't descended, your uterus is in your lungs’ personal space, making it tough to breathe. If it has, it’s sitting on your bladder making you need to go to the bathroom constantly. There’s always a trade off!</li>
    <li>All the room your uterus is taking up is causing distress: heartburn, constipation & more</li>
    <li>you're pretty big! It’s getting hard to move around & very exhausting!</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is baby fully developed at 35 weeks?',
        answer:
          'A baby is not fully developed at 35 weeks. Lung development, increased fat storage and maturation of the digestive system are still occurring.',
      },
      {
        question: 'Can a baby be born at 35 weeks and be healthy?',
        answer:
          'A baby born at 35 weeks is identified as late preterm. Health complications can occur if birth happens at 35 weeks.',
      },
      {
        question: 'What are signs of labor at 35 weeks?',
        answer: `Labor at 35 weeks is considered preterm labor. The signs of labor at 35 weeks can include:
<ul><li>Back pain</li><li>Contractions every 10 minutes or more frequently</li><li>Blood in the vaginal discharge</li><li>Leaking amniotic fluid that appears as vaginal discharge</li><li>Cramps</li><li>More pelvic pressure than usual</li>
</ul>`,
      },
      {
        question: 'How many months is 35 weeks pregnant?',
        answer:
          'A pregnancy at the 35-week mark is considered in the eighth<span>&nbsp;month.',
      },
    ],
  },
  {
    week: 36,
    header: 'Week 36, it’s the final countdown!',
    content: `
    <p>One month is all that separates you from your due date! When you're 36 weeks pregnant, you're gaining a half-pound per week & baby’s growing at a rate of an ounce per day. don't worry! A big portion of your extra weight is just fluids, & those will vacate in one way or another in the days following delivery.</p>
    <p>Baby doesn't have much room to do those cartwheels & acrobatics they practiced in earlier months, but they should be keeping up activity & giving you plenty of kicks & jabs.</p>`,
    symptoms:
      "If it hasn't happened already, soon enough your uterus will descend into your pelvis. This process is called “lightening crotch” & is going to add a whole new level of awkward to your walk. This is actually your first sign that you're ready for labor, which could happen at any time after this! Buckle up, buttercup!",
    yourBaby:`
    <ul>
    <li>Height: 18.66 inches</li>
    <li>Weight: 5.78 lb</li>
    <li>All systems, parts, & everything else are good to go & make their arrival!</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>The descent of your uterus into your pelvis is the first step before labor can occur. Everybody & every baby is different; don't be worried if it hasn't happened yet!</li>
    <li>Still a bunch of trouble sleeping, be sure to sneak in rest whenever you can</li>
    <li>The same (or more) swelling & cramps you have gotten to know over the past few weeks.</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Constant urination </li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is it safe to have a baby at 36 weeks?',
        answer:
          'A baby born at 36 weeks is identified as late preterm. Health complications can occur if birth happens at 36 weeks, but are less likely than at 35 weeks or earlier.',
      },
      {
        question: 'What are the signs of labor at 36 weeks?',
        answer: `Labor at 36 weeks is considered preterm labor. The signs of labor at 36 weeks can include:
<ul><li>Back pain</li><li>Contractions every 10 minutes or more frequently</li><li>Blood in the vaginal discharge</li><li>Leaking amniotic fluid that appears as vaginal discharge</li><li>Cramps</li><li>More pelvic pressure than usual</li>
</ul>`,
      },
      {
        question: 'How do you know when you have dropped?',
        answer:
          'The indicators that your baby has dropped can include pelvic discomfort, increased pelvic pressure, more than usual discharge, even more frequent urination and reduced weight on the diaphragm that results in improved breathing.',
      },
    ],
  },
  {
    week: 37,
    header: 'How does it feel to be in week 37?',
    content: `
    <p>You've entered “early term” (weeks 37-38), which is decidedly a better time to give birth than “pre term” (before week 37). This means that baby is all set for birth & there is a real possibility of you going into labor soon! This is the time to cover all of your bases & go over anything you're unsure about in terms of giving birth. Be sure you’ve mapped out the quickest route to the hospital from home & from work & stock that hospital bag. </p>
    <p>Baby has likely shed all of his lanugo that covered his body to keep him warm. It is actually broken down & digested to help form a sticky black substance called meconium, which is building up in baby’s intestines (you'll see this in the first little dirty diapers you change!). The majority of the vernix caseosa – the waxy substance that covered baby since mid first trimester – goes the same way. With the lanugo & vernix out of the way, your baby has a chance to grow a nice head of hair. </p>
    `,
    symptoms:
      "In labor news, there’s a chance that you will see your mucus plug sometime soon. Lovingly referred to as the “bloody show,” seeing this discharge means that you can expect a birthday pretty soon! On top of the usual physical symptoms, a very common ailment for mommies at 37 weeks pregnant is anxiety. There are a lot of unknowns, & it feels like there are countless things to do before the big day. Our advice? Relax! Your new baby won't care what color the nursery is painted. Take some of the stress away by stocking it up with natural baby products from our baby shop!!",
    yourBaby: `
    <ul>
    <li>Height: 19.13 inches</li>
    <li>Weight: 6.30 lb</li>
    <li>Building up meconium in the lower intestines</li>
    <li>Lanugo (body hair) is shedding</li>
    <li>Practicing breathing by inhaling & exhaling deep breaths of amniotic fluid</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Cervical mucus plug, aka the “bloody show” is not as horrible as its name would make it seem! But it does signal that labor is coming very soon</li>
    <li>A hormone called relaxin is making your joints start… relaxin’! Your joints will feel very loosey goosey for a while</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'What are the signs of labor at 37 weeks?',
        answer: `There are multiple signs of labor at 37 weeks, although there is variation for eachpregnancy. Signs of labor can include:
<ul><li>The baby drops</li><li>Back pain</li><li>Nausea</li><li>Diarrhea</li><li>Water breaking</li><li>Consistent contractions that are more intense and grow in frequency</li><li>Release of the mucus plug that shows as vaginal discharge (can also be tinted    with blood) </li>
</ul>`,
      },
      {
        question: 'Are babies born at 37 weeks ok?',
        answer:
          'Although a baby born at 37 weeks can be healthy, it is ideal for delivery to occur at39 weeks or after.',
      },
      {
        question: 'What are some signs that labor is nearing?',
        answer: `Although every pregnancy is different, there are a few signs that indicate labor isnearing. Among the signs are:
<ul><li>The baby drops in position, reducing weight on the diaphragm and allowing for    improved breathing &nbsp;</li><li>Increased energy and a desire to nest</li><li>Effacement, which is known as thinning of the cervix</li><li>Beginning dilation of the cervix</li><li>Back pain</li><li>Relaxed joints (important for the birth process)</li><li>Increased fatigue</li><li>No longer gaining weight</li><li>Diarrhea</li>
</ul>`,
      },
    ],
  },
  {
    week: 38,
    header: '38 Weeks Pregnant – 2 Weeks Until The Due Date!',
    content: `
    <p>Your baby is reaching nearly 7 pounds!! And, guess what?! Your baby is still growing! Talking is becoming a little challenge, as is getting dressed & everything else at this point!</p>
    <p>Baby is ready to go, it’s up to your body to decide when the big day is. On top of growing out in size, your baby is growing out their hair & nails. </p>`,
    symptoms:
      'Baby is probably riding pretty low in your pelvis right now, which could be leading to some shooting sensations in your legs & pelvis. This is because baby is big enough that they may start accidentally stepping on some nerves down there, which will feel pretty weird! The size & position of your baby has probably turned you into one of the least graceful people you know. You still have two weeks left until your predicted due date, but it’s only going to get more awkward to move around. This means you should get all of your preparations done as soon as possible. Be sure to enlist the help of your partner! Just remember not to stress, it’s impossible to get everything done!',
    yourBaby: `
    <ul>
    <li>Height: 19.61 inches </li>
    <li>Weight: 6.80 lb</li>
    <li>Hair & nails are growing, baby could have over an inch of hair by now</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Plenty of Braxton Hicks/practice contractions, which can be easy to mistake for the real thing! Real contractions happen with regularity & get stronger as time passes.</li>
    <li>Feeling nervousness, anxiety, or just maybe plain sick of being pregnant</li>
    <li>Bouts of diarrhea? Look out, this can be a sign that you're ready for labor!</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'What are labor signs at 38 weeks?',
        answer: `There are multiple signs of labor at 38 weeks, although there is variation for eachpregnancy. Signs of labor can include:
<ul><li>The baby drops</li><li>Back pain</li><li>Nausea</li><li>Diarrhea</li><li>Water breaking</li><li>Consistent contractions that are more intense and grow in frequency</li><li>Release of the mucus plug that shows as vaginal discharge (can also be tinted    with blood) </li>
</ul>`,
      },
      {
        question: 'Is 38 Weeks safe for delivery?',
        answer:
          'Although delivery at 39 weeks or after is preferred in order to avoid complications,delivery at 38 weeks can be safe.',
      },
      {
        question: 'Can vomiting be a sign of labor?',
        answer:
          'Vomiting may be a sign of labor, along with nausea and diarrhea. However, vomitingcan also be an indicator of illness or a complication, so to be safe, consult with a medicalprofessional.',
      },
    ],
  },
  {
    week: 39,
    header: '39 Weeks Pregnant: 1 Week before the Due Date!',
    content: `
    <p>You’ve officially entered full-term pregnancy. The moment you’ve been waiting for is coming up. Researchers theorize that when your baby is ready for birth, they send chemical signals to the body to initiate labor. That’s why they say: “only a baby knows when it’s ready to be born”!</p>
    <p>This week your baby is likely able to flex all of their limbs, even though at 39 weeks pregnant there isn't much room left to do that anymore. All of this crowding, on top of their new position in your pelvis & the simple fact that you’ve been carrying them for 273 days may leave you feeling seriously impatient! That’s very natural, & there are a lot of people who believe feeling sick of pregnancy at this stage is actually your body preparing you for when it’s over.</p>`,
    symptoms:
      "There's a pretty good chance that every day feels like it could be the day, & you imagine rushing to the hospital to give birth at every muscle cramp. Constant speculation from friends & relatives probably isn't helping! Our advice is to do your best to take your mind off of it. Your due date at 40 weeks may come & go, but try to make plans every day that will keep you from stressing. ",
    yourBaby: `
    <ul>
    <li>Height: 19.96 inches</li>
    <li>Weight: 7.25 lb</li>
    <li>Baby is ready for birth! </li>
    <li>Lungs are mature, & reflexes are strong</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Cervix starts dilating</li>
    <li>Mucus plug may pass</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'What are the signs of labor at 39 weeks?',
        answer: `There are multiple signs of labor at 39 weeks, although there is variation for eachpregnancy. Signs of labor can include:
<ul><li>The baby drops</li><li>Back pain</li><li>Nausea</li><li>Diarrhea</li><li>Water breaking</li><li>Consistent contractions that are more intense and grow in frequency</li><li>Release of the mucus plug that shows as vaginal discharge (can also be tinted    with blood) </li>
</ul>`,
      },
      {
        question: 'Is tightening of the stomach a sign of labor?',
        answer:
          'Tightening of the stomach can occur throughout pregnancy, and for different reasons.In the third trimester, tightening of the stomach may be a sign of labor. Stomach tightening can beassociated with contractions.',
      },
    ],
  },
  {
    week: 40,
    header: '40 Weeks Pregnant – The Week of the Due Date!',
    content: `
    <p>CONGRATULATIONS! After 280 days, you’ve miraculously managed to grow a real live human being. WOW! This week is what you’ve been waiting for: your due date!</p>
    <p>Even though your due date is this week, remember that only 5% of pregnant women actually give birth on their due date. Nobody but your baby knows when it’s time, so do what you can to keep your mind off the big unknown. It will happen soon enough!</p>`,
    symptoms:
      "Packed...squished...probably even a little (ok a lot) uncomfortable but your baby seems to be comfy, right? All the things are happening...just maybe not so glamorous things. Vaginal discharge...leaky boobs...maybe you even pee your pants a little...all the symptoms will pay off!",
    yourBaby: `
    <ul>
    <li>Height: 20.16 inches </li>
    <li>Weight: 7.63 lb</li>
    <li>Fully developed & waiting for birth</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Labor signs like contractions, water breaking! LET'S DO THIS!</li>
    </ul>`,
    faq: [
      {
        question: 'What are the signs of labor at 40 weeks?',
        answer: `There are multiple signs of labor at 40 weeks, although there is variation for eachpregnancy. Signs of labor can include:
<ul><li>The baby drops</li><li>Back pain</li><li>Nausea</li><li>Diarrhea</li><li>Water breaking</li><li>Consistent contractions that are more intense and grow in frequency</li><li>Release of the mucus plug that shows as vaginal discharge (can also be tinted    with blood) </li>
</ul>`,
      },
      {
        question: 'What causes a baby to be overdue?',
        answer:
          'What causes a baby to be overdue is not always identified. Factors that cancontribute to an overdue or post-term pregnancy are heredity, obesity, first pregnancies, previous post-termpregnancies and even due dates that are miscalculated.',
      },
      {
        question: 'How many months is 40 weeks pregnant?',
        answer: 'A 40 weeks a pregnancy is in month nine.',
      },
      {
        question: 'Is it dangerous to go past 40 weeks pregnant?',
        answer:
          'Pregnancy at 40 weeks is considered full term and not overdue or post-term. Therefore, pregnancyup to 42 weeks is still considered within the range of a healthy pregnancy, although increased monitoringmay occur past 40 weeks.',
      },
    ],
  },
  {
    week: 41,
    header: 'Welcome to week 41!',
    content: `
    <p>CONGRATULATIONS! After 280 days, you’ve miraculously managed to grow a real live human being. WOW! This week is what you’ve been waiting for: your due date!</p>
    <p>Even though your due date is this week, remember that only 5% of pregnant women actually give birth on their due date. Nobody but your baby knows when it’s time, so do what you can to keep your mind off the big unknown. It will happen soon enough!</p>`,
    symptoms:
      "Packed...squished...probably even a little (ok a lot) uncomfortable but your baby seems to be comfy, right? All the things are happening...just maybe not so glamorous things. Vaginal discharge...leaky boobs...maybe you even pee your pants a little...all the symptoms will pay off!",
    yourBaby: `
    <ul>
    <li>Height: 20.4 inches</li>
    <li>Weight: 8.3 lb</li>
    <li>Dry Skin</li>
    <li>Descent into Pelvis </li>
    <li>Fully developed & waiting for birth</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Signs of Labor</li>
    <li>Fatigue</li>
    <li>Pelvic Pressure</li>
    <li>Back Pain</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Hemorrhoids</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is it safe to go past 41 weeks pregnant?',
        answer:
          'A full-term pregnancy ranges between 39 and 42 weeks, and therefore pregnancy past 41weeks is still considered safe. Due dates can also be miscalculated. Medical practitioners will monitor ifneeded.',
      },
      {
        question: 'How long do they wait to induce labor after due date?',
        answer:
          'For healthy pregnancies, natural progression is the ideal way to go. However, twoweeks following the due date is a general time indicator of when labor may be induced. Health factors arealso considered when determining possible induction, such as high blood pressure, deficient amniotic fluidor a placental abruption (placenta detaches partially or fully from the uterus).',
      },
      {
        question: 'Is it safe to have a baby at 41 weeks?',
        answer:
          'Yes, it is safe to have a baby at 41 weeks. Full-term babies range between 39 and 42weeks; post-term is after 42 weeks.',
      },
    ],
  },
  {
    week: 42,
    header: '42 Weeks Pregnant – It’s time!',
    content: `
    <p>CONGRATULATIONS! After 280 days, you’ve miraculously managed to grow a real live human being. WOW! This week is what you’ve been waiting for: your due date!</p>
    <p>Even though your due date is this week, remember that only 5% of pregnant women actually give birth on their due date. Nobody but your baby knows when it’s time, so do what you can to keep your mind off the big unknown. It will happen soon enough!</p>`,
    symptoms:
      "Packed...squished...probably even a little (ok a lot) uncomfortable but your baby seems to be comfy, right? All the things are happening...just maybe not so glamorous things. Vaginal discharge...leaky boobs...maybe you even pee your pants a little...all the symptoms will pay off!",
    yourBaby: `
    <ul>
    <li>Height: 21 inches </li>
    <li>Weight: 8.5 lb</li>
    <li>Dry Skin</li>
    <li>Descent into Pelvis </li>
    <li>Fully developed & waiting for birth</li>
    </ul>`,
    yourBody: `
    <ul>
    <li>Signs of Labor</li>
    <li>Fatigue</li>
    <li>Pelvic Pressure</li>
    <li>Back Pain</li>
    <li>Insomnia / Difficulty Sleeping</li>
    <li>Constipation, heartburn or indigestion</li>
    <li>Hemorrhoids</li>
    <li>Aches & pains</li>
    <li>Constant urination </li>
    <li>Round ligament pain</li>
    <li>Mood swings</li>
    <li>Increased blood pressure</li>
    <li>Braxton hicks</li>
    <li>Restless leg syndrome</li>
    </ul>`,
    faq: [
      {
        question: 'Is being 42 weeks pregnant dangerous?',
        answer:
          'A baby is not considered post-term until after 42 weeks. Being pregnant at 42 weeksis not dangerous unless a medical complication that is affecting the health of mom and/or baby is present.Also consider that some due dates can be miscalculated.',
      },
      {
        question: 'How many weeks overdue is safe?',
        answer:
          'The general number of weeks overdue that is still safe is up to 2 weeks.Considerations at this stage regarding safety include possible miscalculation of the due date and medicalcomplications. Monitoring at 42 weeks will help to ensure safety.',
      },
      {
        question: 'What is the longest a woman has been pregnant?',
        answer:
          'The longest pregnancy documented is 375 days. The normal number of days for a pregnancy is 280 days.',
      },
      {
        question: 'How many months is 42 weeks pregnant?',
        answer:
          'At 42 weeks pregnant, a woman is in her ninth month of pregnancy.',
      },
    ],
  },
];

export default weekByWeekValues;
